var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.columnList.length)?_c('LandingPage',{staticClass:"sp-landing-page",attrs:{"column-list":_vm.columnList}}):_c('NotFoundPage')}
var staticRenderFns = []

export { render, staticRenderFns }